module.exports = __webpack_public_path__ + "img/index-bg.a62fa114.png";